import {IWebsiteTagsState} from "../reducers/website-tags.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getWebsiteTagsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.websiteTags);

export const getWebsiteTags = () => createSelector(getWebsiteTagsState,
  (state: IWebsiteTagsState) =>
    (state && state.entities) ? state.entities : null
);


export const getWebsiteTagsMap = (websiteId: number) => createSelector(getWebsiteTagsState,
  (state: IWebsiteTagsState) =>
    state.entities[websiteId]
);


export const getWebsiteTagsLoading = (websiteId: number) => createSelector(getWebsiteTagsState,
  (state: IWebsiteTagsState) =>
    state.entities[websiteId].loading
);

export const getWebsiteTagsLoaded = (websiteId: number) => createSelector(getWebsiteTagsState,
  (state: IWebsiteTagsState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
